import React from 'react';
import NettRow from './nett-rate-row.jsx';
import CommissionRow from './commission-rate-row.jsx';
import R from 'ramda';
import { connect } from 'react-redux';

const Table = ({ rates, updateType, rateType, commissionPercentage, initialCommissionPercentage, ratePackageName, ...extraProps }) => {
  const TableRow = rateType === 'nett' ? NettRow : CommissionRow;
  const subTitleName = R.cond([
    [R.equals('seasonRates'), R.always(`${R.prop('rateSetName', extraProps)}${R.prop('rateSetCode', extraProps) ? `(${R.prop('rateSetCode', extraProps)})` : ''}`)],
    [R.equals('extras'), R.always(R.prop('extraCode', extraProps))],
    [R.equals('offers'), R.always(R.prop('bookingCode', extraProps))],
    [R.T, R.always('')],
  ])(updateType);
  const subTitleLabel = R.cond([
    [R.equals('seasonRates'), R.always('Rate set name: ')],
    [R.equals('extras'), R.always('Extra code: ')],
    [R.equals('offers'), R.always('Booking code: ')],
    [R.T, R.always('')],
  ])(updateType);
  return (
    <div style={{ paddingTop: '8px', fontSize: '12px' }}>
      <div style={{ textTransform: 'uppercase' }}>
        {subTitleName ? <div>{subTitleLabel}<b>{subTitleName}</b></div> : ''}
        {ratePackageName ? <div>Rate Package: <b>{ratePackageName}</b></div> : ''}
      </div>
      {
        rateType === 'commission' ? (
          <div style={{ fontSize: '12px', color: initialCommissionPercentage && initialCommissionPercentage !== commissionPercentage ? '#009688' : '' }}>
            { commissionPercentage ? <div><b>{commissionPercentage}</b> % COMMISSION</div> : '' }
          </div>
        ) : <div/>
      }
      <TableRow isHeader />
      {
        R.compose(
          R.addIndex(R.map)((rateDetail, index) => <TableRow key={index} index={index} {...rateDetail} />),
          R.reject(R.prop('notApplicable'))
        )(rates)
      }
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  rateType: contracting.massRateChange.get('rateType'),
  updateType: contracting.massRateChange.get('updateType'),
});

export default connect(mapStateToProps)(Table);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/single-product/rates-table/rate-table.jsx